module.exports = __webpack_public_path__ + "img/mz.0e015400.jpg";